export default [
  // 消息中心
  {
    path: '/mesage',
    name: 'mesage',
    meta: {
      mustLogin: true,
      theme: '',
      pageTitle: 'select',
    },
    component: () => import('@/views/mesage.vue'),
  },
  // 帮助中心
  {
    path: '/cms/:id?',
    name: 'cms',
    meta: {
      theme: '',
      pageTitle: 'select',
    },
    component: () => import('@/views/cms.vue'),
  },
  // 公告
  {
    path: '/noticeInfo/:ntId?',
    name: 'noticeInfo',
    meta: {
      pageTitle: 'select',
    },
    component: () => import('@/views/noticeInfo.vue'),
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    meta: {
      appRouter: 'login', // 在app中访问APP
      isCoOpen: true,
    },
    component: () => import('@/views/login.vue'),
  },
  // 注册
  {
    path: '/register',
    name: 'register',
    meta: {
    },
    component: () => import('@/views/Register.vue'),
  },
  // 找回密码
  {
    path: '/resetPass',
    name: 'resetPass',
    meta: {
      isCoOpen: true,
    },
    component: () => import('@/views/resetPass.vue'),
  },
  // 订单中心new
  {
    path: '/order',
    name: 'order',
    component: () => import('@/views/order/index.vue'),
    children: [
      // 币币订单
      {
        path: 'exchangeOrder',
        name: 'orderExchangeOrder',
        meta: {
          mustLogin: true,
          navName: 'exchangeOrder',
          activeName: 'order',
          pageTitle: 'order',
        },
        component: () => import('@/views/order/exchangeOrder.vue'),
      },
      // 法币订单
      {
        path: 'otcOrder',
        name: 'orderOtcOrder',
        meta: {
          mustLogin: true,
          navName: 'otcOrder',
          pageTitle: 'order',
          activeName: 'order',
        },
        component: () => import('@/views/order/otcOrder.vue'),
      },
      // 合约订单
      {
        path: 'coOrder',
        name: 'OrderCoOrder',
        meta: {
          mustLogin: true,
          navName: 'coOrder',
          activeName: 'order',
          pageTitle: 'order',
        },
        component: () => import('@/views/order/coOrder.vue'),
      },
    ],
  },
  // app download
  {
    path: '/install',
    name: 'install',
    redirect: '/download',
    meta: {
      theme: 'homeOther',
    },
    component: () => import('@/views/appDownload.vue'),
  },
  // 提交工单
  {
    path: '/work-order',
    name: 'workOrder',
    meta: {
    },
    component: () => import('@/views/workOrder.vue'),
  },
  {
    path: '/download',
    name: 'download',
    meta: {
      theme: 'homeOther',
    },
    component: () => import('@/views/appDownload.vue'),
  },
  {
    path: '/appDownload',
    name: 'appDownload',
    meta: {
      theme: 'homeOther',
      pageTitle: 'appDownload',
    },
    component: () => import('@/views/appDownload.vue'),
  },
];
